import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { IconButton, Badge } from '@material-ui/core'
import { Notifications as NotificationsIcon } from '@material-ui/icons'
import { subscribe } from '../../SocketIo/Socket'

const NotificationBell = ({ url, user, onOpen, unreadCount, onCountChange }) => {
  // Poll for unread count on mount
  React.useEffect(() => {
    const fetchCount = () => {
      axios.get(`${url}/api/bid-estimation/notifications/unread-count`).then(res => {
        if (onCountChange) onCountChange(res.data.count || 0)
      }).catch(() => {})
    }
    fetchCount()
    const interval = setInterval(fetchCount, 30000)
    return () => clearInterval(interval)
  }, [url])

  // Socket subscription — increment on new notification
  React.useEffect(() => {
    if (!user?._id) return
    const cleanup = subscribe(`${user._id}_tasks`, (data) => {
      if (data?.type === 'bid_notification') {
        if (onCountChange) onCountChange(prev => typeof prev === 'number' ? prev + 1 : 1)
      }
    })
    return cleanup
  }, [user?._id])

  return (
    <IconButton size="small" onClick={onOpen} style={{ color: '#fff' }}>
      <Badge badgeContent={unreadCount || 0} color="error" invisible={!unreadCount}>
        <NotificationsIcon fontSize="small" />
      </Badge>
    </IconButton>
  )
}

const mapStateToProps = (state) => ({
  url: state.url,
  user: state.user
})

export default connect(mapStateToProps)(NotificationBell)
